/* Maps an expense ReportStatus (accounting-api: OPEN/SUBMITTED/APPROVED/REJECTED) to
   the matching Nomad Badge variant + label. Filled (intent="background") subtle pills,
   matching the approved Reports mockup. */
import { Badge, type BadgeProps } from '@andavo/web-ui';
import type { ReportStatus } from './hooks/use-reports';

const STATUS_CONFIG: Record<
  ReportStatus,
  { label: string; variant: NonNullable<BadgeProps['variant']> }
> = {
  OPEN: { label: 'Open', variant: 'default' },
  SUBMITTED: { label: 'Submitted', variant: 'blue' },
  APPROVED: { label: 'Approved', variant: 'success' },
  REJECTED: { label: 'Rejected', variant: 'danger' },
};

export function StatusBadge({ status }: { status: ReportStatus }) {
  const { label, variant } = STATUS_CONFIG[status];
  return (
    <Badge variant={variant} intent="background" borderRadius="round">
      {label}
    </Badge>
  );
}
